import { Color } from "@starrez/starryui";
import styled from "styled-components";

export const EmptyPreviewDiv = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 8px;
    color: ${Color.Grey.G80};
    justify-content: center;
    text-align: center;
`;

export const PreviewIframe = styled.iframe`
    border: 0;
    height: 100%;
    width: 100%;
`;
